import axios from 'axios';

const API = axios.create({
  baseURL: 'http://44.213.60.210:3006/api', // or just '/api' if proxy is set
});

// API Functions
export const fetchStudents = () => API.get('/getStudents');
export const fetchStudent = (id) => API.get(`/getStudent/${id}`);
export const createStudent = (data) => API.post('/postStudents', data);
export const updateStudent = (id, data) => API.put(`/updateStudent/${id}`, data);
export const deleteStudent = (id) => API.delete(`/deleteStudent/${id}`);
